export default {
  version: '請選擇適合您的版本下載',
  btn: {
    android: 'Android',
    ios: 'iOS',
    huawei: 'HarmonyOS',
  },

  huaweiDownloadTips: '華為HarmonyOS Next下載說明',
  huawei: {
    title: '華為HarmonyOS Next下載',
    subTitle: '安裝 WeMust App 說明',
    appName: '卓易通',

    explanationTitleOne: '1、安裝卓易通APP',
    explanationContentOne: '請在【應用市場】安裝【卓易通】',

    explanationTitleTwo: '2、查找搜應用',
    explanationContentTwo: '安裝後，桌面【卓易通】文件夾內含【搜應用】',

    explanationTitleThree: '3、安裝Android APP',
    explanationContentThree: '點擊【搜應用】，並打開安裝地址（<a class="link" href="{jumpUrl}" target="_blank">{link}</a>），點擊安裝 Android APP',

    explanationTitleFour: '4、選擇並安裝 WeMust apk',
    explanationContentFour: '下載完成後，點擊【菜單】-【下載】- 選擇要安裝的apk',
  },
  tips: '掃碼下載App',
  copyRight: '澳門科技大學 版權所有',
  auth: `${new Date().getFullYear()} WeMust All Rights Reserved`,
  download_tip: {
    text1: '請點擊右上角的',
    text2: '選擇“在瀏覽器中開啟”',
  },
};
